var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhiteSound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.78564 8.78558V12.2141C2.78564 12.6856 3.17136 13.0713 3.64279 13.0713H6.21422L9.03422 15.8913C9.57422 16.4313 10.4999 16.0456 10.4999 15.2827V5.70844C10.4999 4.94558 9.57422 4.55986 9.03422 5.09986L6.21422 7.92844H3.64279C3.17136 7.92844 2.78564 8.31415 2.78564 8.78558ZM14.3571 10.4999C14.3571 8.98272 13.4828 7.67986 12.2142 7.04558V13.9456C13.4828 13.3199 14.3571 12.017 14.3571 10.4999ZM12.2142 4.02843V4.19986C12.2142 4.52558 12.4285 4.80844 12.7285 4.92844C14.9399 5.81129 16.4999 7.97986 16.4999 10.4999C16.4999 13.0199 14.9399 15.1884 12.7285 16.0713C12.4199 16.1913 12.2142 16.4742 12.2142 16.7999V16.9713C12.2142 17.5113 12.7542 17.8884 13.2514 17.6999C16.1571 16.5942 18.2142 13.7913 18.2142 10.4999C18.2142 7.20844 16.1571 4.40558 13.2514 3.29986C12.7542 3.10272 12.2142 3.48843 12.2142 4.02843Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteSound);
export default __webpack_public_path__ + "static/media/White-Sound.012befa8ca56565421fb9892742aca89.svg";
export { ForwardRef as ReactComponent };